import {Component, DoCheck, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseComponent, WmsToggleComponent, WmsTypeaheadComponent} from "@wms/components";
import {FormControl, FormsModule} from "@angular/forms";
import {TabsModule} from "ngx-bootstrap/tabs";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {OrderByPipe} from "@wm/components-base";
import {getClonedObject, getCurrencyOptions, getDateTimePatterns, getFormatPatterns, getTimePatterns} from "@wms/core";
import {CURRENCY_INFO} from "@wm/core";
import {CheckboxsetComponent, EventHandlerComponent} from "@wms/properties-panel";
import {isArray, set, toString} from "lodash-es";
import {SelectComponent} from "@wm/design-runtime";
import { BaseVariableService } from '@wms/app/variables';
import {LiveWidgetUtilsService} from "@wms/app/services/liveWidgetUtils/live-widget-utils.service";
import { WmsExpressionErrorDirective } from '@wms/app/directives/wms-expression-error/wms-expression-error.directive';


@Component({
  selector: 'wms-basic',
  standalone: true,
  imports: [CommonModule, WmsTypeaheadComponent, FormsModule, WmsToggleComponent, TabsModule, TooltipModule, OrderByPipe, CheckboxsetComponent, SelectComponent, EventHandlerComponent, WmsExpressionErrorDirective],
  templateUrl: './basic.component.html',
  styleUrls: ['./basic.component.less']
})
export class BasicComponent extends BaseComponent  implements OnInit {
  @Input() liveWidgetSettingsService: any;
  @Input() customPipeOptions: any
  @Input() fieldsList: any;
  @Input() pipesArr: any
  @Input() groupbyDisplayOptions: any
  @Input() displayfieldArray: any;
  @Input() datafieldArray: any;
  @Input() filterDisplayfieldArray: any;
  @Input() isBoundToLiveVariable: any;
  @Input() groupList: any;
  @Input() filterDatafieldArray: any;
  @Output() setCustomPipeConfig = new EventEmitter<any>();
  @Output() updateFormatPattern = new EventEmitter<any>();
  @Output() widgetChange = new EventEmitter<any>();
  @Output() changeGroup = new EventEmitter<any>();
  @Output() onFilterDataSetChange = new EventEmitter<any>();
  @Output() onDataSetChange = new EventEmitter<any>();
  @Output() validateAndUpdateExpression = new EventEmitter<any>();
  formatPatterns: any;
  datetimePatterns: any
  currencyPatterns: any
  timePatterns: any
  formatter: any;
  editableWidgetOptions: any = [];
  textInputTypeOptions: any = [];
  filterWidgetOptions: any = [];
  convertToString = toString;
  errorMessage: any;
  variableService: BaseVariableService;
  liveWidgetUtils: LiveWidgetUtilsService
  indexOf = Array.prototype.indexOf;
  protected  CURRENCY_INFO = CURRENCY_INFO;


  constructor() {
    super()
    this.variableService = inject(BaseVariableService);
    this.liveWidgetUtils = inject(LiveWidgetUtilsService);
  }

  ngOnInit(): void {

    this.errorMessage = {};
    this.formatPatterns = getClonedObject(getFormatPatterns());
    this.formatPatterns.sort();
    this.datetimePatterns = getClonedObject(getDateTimePatterns());
    this.currencyPatterns = getClonedObject(getCurrencyOptions());
    this.timePatterns = getClonedObject(getTimePatterns());





    this.editableWidgetOptions = ['text', 'number', 'textarea', 'password', 'checkbox', 'toggle', 'slider', 'richtext', 'currency',
      'switch', 'select', 'checkboxset', 'radioset', 'date', 'time', 'timestamp', 'rating', 'datetime', 'autocomplete', 'chips', 'colorpicker', 'upload'];
    this.editableWidgetOptions.sort()
    this.textInputTypeOptions = ['color', 'date', 'datetime-local', 'email', 'month', 'number', 'password', 'search', 'tel', 'text', 'time', 'url', 'week'];
    this.textInputTypeOptions.sort()
    this.filterWidgetOptions = ['text', 'number', 'select', 'autocomplete', 'date', 'time', 'datetime'];
    this.filterWidgetOptions.sort()
  }

  setCustomPipeConfigs(exp: any) {
    this.setCustomPipeConfig.emit(exp);

  }

  updateFormatPatterns(expr: any) {
    this.updateFormatPattern.emit(expr);

  }

  widgetChanges(widget: any) {
    this.widgetChange.emit(widget)
  }

  changeGroups(group?: any, selectedGroupVal?: any) {
    console.log('group', selectedGroupVal)
    group = selectedGroupVal;
    this.changeGroup.emit(group?.field);

  }

  filterWidgetChange() {
    let field = this.liveWidgetSettingsService.selectedComponent.field;
    field.filterdataset = field.filterdisplayfield = field.filtersearchkey =
      field.filterdisplaylabel = field.filterdatafield = field.filteronfilter = undefined;
    field.filterinputtype = 'text';
  };

  resetDefaultWidgetConfig() {
    if( this.liveWidgetSettingsService.selectedComponent.field.widgetType === "undefined") {
      this.liveWidgetSettingsService.selectedComponent.field.customExpression = undefined;
    }else {
      let column = this.liveWidgetSettingsService.selectedComponent.field;
      this.liveWidgetSettingsService.selectedComponent.field.customExpression = '';
      this.liveWidgetUtils.setColumnConfig(column);
      this.liveWidgetSettingsService.onExpressionChange(column);
    }

  };


  @Input() set filterdataset(val: string) {
    this.onFilterDataSetChange.emit();
  }
  @Input()set widgetDataSet(val:string){
      this.onDataSetChange.emit();
  }

  handelChangesFilterSearchKey(val: any) {
    this.liveWidgetSettingsService.selectedComponent.field.filtersearchkey = val[0]
  }

  handelChangesSearchKey(val: any) {
    this.liveWidgetSettingsService.selectedComponent.field.searchkey = isArray(val)? val.join(): val;
  }

  onDisplayNameChange() {
    let field = this.liveWidgetSettingsService.selectedComponent.field.field;
    let headerField = this.getSelectedHeaderConfigField(this.liveWidgetSettingsService.headerConfig, field);
    if (headerField) {
      headerField.displayName = this.liveWidgetSettingsService.selectedComponent.field.displayName;
    }
  }

  getSelectedHeaderConfigField(fields: any[], field: string) {
    let match = fields.find((config: any) => { return !config.isGroup && config.field === field});
    if (!match) {
       let matchGroup = fields.find((config: any) => {
        if (config.isGroup) {
          match = this.getSelectedHeaderConfigField(config.columns, field);
          if (match) {
            return true;
          }
        }
        return false;
      });
    }
    return match;
  }

  showOrHideMatch(widget:any){
    this.liveWidgetSettingsService.selectedComponent.field.groupby = widget.name;
    this.liveWidgetSettingsService.showOrHideMatchProperty();

  }
  toToggle(property:string,event:any){
    set(this.liveWidgetSettingsService.selectedComponent.field,property,event);

  }
  onFilterOnFieldSelected(fieldType:string ,selectedValue:any){
    set(this.liveWidgetSettingsService.selectedComponent.field,fieldType,selectedValue.value)
  }

  checkVariableType(){
    const instance = this.variableService.getVariableInstance(this.liveWidgetSettingsService.variableName, undefined);
    // Fix for [WMS-27779]: added validation check and hiding Caseinsensitive sort property if there is no instance(If variable is deleted)
    return instance && !(instance.category === 'wm.LiveVariable' || (instance.category === 'wm.ServiceVariable' && instance.hasPagination()));
  }
}
